import kyWithSentry from './helper/kyWithSentry';

import getArtistsOnSocial from 'url-constructors/getArtistsOnSocial';
import getEntityMetadataByIdsURL from 'url-constructors/getEntityMetadataByIdsURL';

const getFollowersData = (options: any): any =>
  kyWithSentry.get(getArtistsOnSocial(options)).json();

const getArtistsData = ({ body }: any): any =>
  kyWithSentry
    .post(getEntityMetadataByIdsURL({ entityType: 'artist' }), { json: body })
    .json();

const topPerformingArtistsOnSocialInterceptor = async (
  input: RequestInfo /* eslint-disable-line */,
  init: RequestInit | undefined /* eslint-disable-line */,
  interceptionData?: {
    limit: number;
    offset: number;
    platformFilter: string[];
    sortBy: string;
    sortOrder: 'asc' | 'desc';
  }
): Promise<Response> => {
  try {
    const followersData = await getFollowersData(interceptionData);
    const artistsIds =
      followersData &&
      followersData.length > 0 &&
      followersData[0].artists.reduce(
        (prev: any, current: any) => [...prev, String(current.artistId)],
        []
      );
    const totalLimit =
      followersData && followersData.length > 0 && followersData[0]?.totalCount;
    const artistsMetadata = await getArtistsData({ body: artistsIds });

    /** TODO: remove this line when the DF issue is fixed */
    const validData = artistsMetadata
      .filter((item: any) => !item.hasOwnProperty('code'))
      .map((item: any) => ({
        ...item,
        followers: followersData[0].artists.find(
          (artist: any) => String(artist.artistId) === item?.entity?.id
        )?.followers,
      }));

    return new Response(
      JSON.stringify({
        data: validData,
        totalLimit,
      })
    );
  } catch (error) {
    return new Response(JSON.stringify({ reason: error.message }));
  }
};

export default topPerformingArtistsOnSocialInterceptor;
